<script setup lang="ts">
import GlobalContextMenu from './globalContextMenu.vue'
import { computed, onMounted, ref, useRoute } from '#imports'
import { useAuthStore } from '../../../stores/authStore.js'

const isAdmin = ref(false)
onMounted(() => {
  const authStore = useAuthStore()
  isAdmin.value = authStore.authorized
})

const route = useRoute()
const isAdminRoute = computed(() =>
  route.path === '/admin' || route.path.startsWith('/admin/')
)
</script>

<template>
  <ClientOnly>
    <div v-if="isAdmin && !isAdminRoute">
      <GlobalContextMenu />
    </div>
  </ClientOnly>
</template>
